export default {
  advert: {
    list: '广告列表',
    archiveList: '归档记录',
    add: '新增广告',
    edit: '编辑广告',
    basicInfo: '基本信息',
    deliverySettings: '投放设置',
    advertName: '广告名称',
    advertNamePlaceholder: '请输入广告名称',
    advertNameTip: '广告名称允许重复，系统将通过广告编码进行区分；最多 30 个字符。',
    advertCode: '广告编码',
    advertType: '广告类型',
    secondaryScreenAdvert: '副屏广告',
    advertTypeTip: '广告类型与投放渠道分开；桌面收银机渠道固定为副屏广告。',
    positionType: '投放位置',
    secondaryScreenStandby: '副屏待机',
    standbyPositionTip: '桌面收银机无操作时，广告占满顾客副屏，用于待机页面展示。',
    secondaryScreenSplit: '副屏分屏',
    splitPositionTip: '桌面收银机操作中展示；顾客副屏一半显示购物车，一半显示广告。',
    recommendedSize: '建议尺寸 {size}',
    effectiveRule: '生效规则',
    effectiveRuleTip: '投放渠道、投放位置和时间均查重，同一门店最多生效 1 个广告。',
    channelType: '投放渠道',
    cashier: '桌面收银机',
    channelTypeTip: '当前原型仅配置桌面收银机渠道，后续渠道在广告中心统一扩展。',
    applicableStores: '适用门店',
    allStores: '全部门店',
    specifiedStores: '指定门店',
    specifiedStoreParticipation: '指定门店参与',
    noStoreSelected: '暂未选择门店',
    selectedStores: '已选择 {count} 家门店',
    selectStores: '选择门店',
    storeDialogTitle: '{name} - 适用门店',
    applicableRule: '适用规则',
    storeTotal: '门店总数：{count} 家',
    sequence: '序号',
    shopName: '门店名称',
    shopCode: '门店编码',
    region: '区域',
    city: '城市',
    enableStatus: '启用状态',
    enabled: '启用',
    storeDisabled: '停用',
    deliveryType: '投放方式',
    longTerm: '长期投放',
    scheduled: '指定时间投放',
    designatedTime: '指定时间',
    deliveryTime: '投放时间',
    deliveryTimeTip: '长期投放不设置结束时间；指定时间需选择完整的开始和结束时间。',
    to: '至',
    image: '广告图片',
    uploadImage: '上传图片',
    imageTip: '请选择 1 至 5 张图片，图片顺序即广告展示顺序',
    imageFormatTip: '支持 JPG、PNG，单张不超过 5 MB；建议尺寸 1920 × 1080，最多上传 5 张。',
    imageCount: '{count} 张图片',
    advertStatus: '广告状态',
    timeStatus: '时间状态',
    creator: '创建人',
    updateTime: '更新时间',
    all: '全部',
    draft: '草稿',
    published: '已发布',
    disabled: '已停用',
    notStarted: '未开始',
    delivering: '投放中',
    ended: '已结束',
    detail: '详情',
    publish: '发布',
    disable: '停用',
    archive: '归档',
    unarchive: '取消归档',
    deleteDraft: '删除草稿',
    confirm: '确认',
    saveDraft: '保存为草稿',
    saveSuccess: '广告保存成功',
    draftSaveSuccess: '草稿保存成功',
    publishSuccess: '广告发布成功',
    discardChangesTitle: '放弃未保存的修改',
    discardChangesMessage: '当前页面存在未保存内容，放弃后本次修改将无法恢复。',
    continueEditing: '继续编辑',
    discardChanges: '放弃修改',
    publishConfirm: {
      conflictTip: '检测到 {count} 条广告与当前投放配置冲突，请先处理冲突广告',
      viewConflict: '查看冲突广告',
    },
    conflictDialog: {
      title: '查看冲突广告',
      alert: '发布当前广告与 {count} 条已发布广告存在投放冲突，请先停用冲突广告，或返回调整投放配置。',
      batchDisable: '批量停用',
      selectTip: '请选择需要停用的广告',
      maxDisableTip: '单次最多停用 100 条广告',
      disableConfirmTitle: '停用冲突广告',
      disableConfirmMessage: '确认停用冲突广告“{name}”吗？停用后将立即停止投放，历史配置保留。',
      batchDisableConfirmMessage: '确认停用已选择的 {count} 条冲突广告吗？停用后将立即停止投放，历史配置保留。',
      confirmDisable: '确认停用',
      disableSuccess: '停用成功',
    },
    specifiedStoreCount: '指定门店 {count}',
    specifiedStoreParticipationCount: '指定门店参与（{count}家）',
    actionDialog: {
      publish: {
        title: '发布广告',
        description: '发布后，广告将按投放时间自动开始或结束投放。',
        warning: '发布前将校验同一投放渠道、同一投放位置、重叠时间及适用门店冲突。',
      },
      disable: {
        title: '停用广告',
        description: '停用后将立即停止广告投放，历史配置保留，可编辑后重新发布。',
        warning: '',
      },
      archive: {
        title: '归档广告',
        description: '归档后将从广告列表移入归档记录，广告状态和投放记录保持不变。',
        warning: '',
      },
      unarchive: {
        title: '取消归档',
        description: '取消归档后，广告将恢复到广告列表，原有配置保持不变。',
        warning: '',
      },
      delete: {
        title: '删除草稿',
        description: '删除后将无法恢复，请确认广告信息。',
        warning: '',
      },
    },
    operationSuccess: '{operation}成功',
    selectImage: '请选择广告图片',
    selectStore: '请选择适用门店',
    selectDeliveryTime: '请选择投放时间',
    endTimeAfterStart: '投放结束时间必须晚于开始时间',
  },
};
